/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}


export const validator = {
  // async-validator 所有验证规则 通用的独立出来
  phone: [
    {
      required: true,
      validator: (rule, value, callback) => {
        var pattern = /^[1][0-9]{10}$/;
        if (!value) {
          callback(
            document.cookie.indexOf("en-US") === -1
              ? "请输入手机号码"
              : "Please enter your phone number"
          );
        } else if (pattern.test(value)) {
          callback();
        } else {
          callback(
            document.cookie.indexOf("en-US") === -1
              ? "请输入正确的手机号码"
              : "Please enter your correct phone number"
          );
        }
      },
      trigger: "blur",
    },
  ],
  idNumber: [
    {
      required: true,
      validator: (rule, value, callback) => {
        var pattern =
          /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
        if (!value) {
          callback(
            document.cookie.indexOf("en-US") === -1
              ? "请输入身份证号码"
              : "Please enter the ID card No"
          );
        } else if (pattern.test(value)) {
          callback();
        } else {
          callback(
            document.cookie.indexOf("en-US") === -1
              ? "请输入正确的身份证号码"
              : "Please enter a correct ID card No."
          );
        }
      },
      trigger: "blur",
    },
  ],
  mailbox: [
    {
      required: true,
      validator: (rule, value, callback) => {
        const mailReg = /([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (!value) {
          return callback(
            new Error(
              document.cookie.indexOf("en-US") === -1
                ? "邮箱不能为空"
                : "The mailbox cannot be empty"
            )
          );
        }
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(
            new Error(
              document.cookie.indexOf("en-US") === -1
                ? "请输入正确的邮箱格式"
                : "Please enter the correct email format"
            )
          );
        }
      },
      trigger: "blur",
    },
  ],
  userName: [
    {
      //用户名正则，4到16位（字母，数字，下划线，减号）
      required: true,
      validator: (rule, value, callback) => {
        if (!value) callback("请输入用户名");
        if (value.length < 4) callback("用户名不能小于4位");
        if (value.length > 16) callback("用户名不能大于16位");
        var pattern = /^[a-zA-Z0-9_-]{4,16}$/;
        if (pattern.test(value)) {
          callback();
        } else {
          callback("请输入正确的用户名");
        }
      },
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: "用户名不能为空",
      trigger: "blur",
    },
    {
      type: "string",
      min: 3,
      message: "用户名不能小于4位",
      trigger: "blur",
    },
    {
      type: "string",
      max: 15,
      message: "用户名不能大于15位",
      trigger: "blur",
    },
  ],
  captcha: [
    {
      required: true,
      message: "验证码为必填选项",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "密码不能为空",
      trigger: "blur",
    },
    {
      type: "string",
      min: 4,
      message: "密码不能小于4位",
      trigger: "blur",
    },
    {
      type: "string",
      max: 12,
      message: "密码不能大于12位",
      trigger: "blur",
    },
  ],
  postcode: [
    // 验证邮编
    {
      validator: (rule, value, callback) => {
        if (value) {
          if (/^[1-9]\d{5}(?!\d)$/g.test(value)) {
            callback();
          } else {
            callback("请输入正确的邮编");
          }
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
};
